export const getReportUrl = (baseUrl: string) => {
  const reportUrl = `${baseUrl}/conversation-reports`
  return {
    GET_MY_REPORTS: `${reportUrl}/me`,
    GET_REPORT_DETAIL: (report_id: number) => `${reportUrl}/${report_id}`,
    DELETE_REPORT: (report_id: number) => `${reportUrl}/${report_id}`,
    GET_LAST_MINDSET: () => `${reportUrl}/me/last-mindset`
  }
}
